<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <v-icon class="page-icon" color="#2e384d" size=60>mdi-car-arrow-left</v-icon>
      <p class="desc">{{ $t('enterCarRegNum.description') }}</p>
      <form action="#" @submit.prevent="submit">
        <LabelTextField 
          ref="licensePlateNumber" 
          class="mt-3" 
          :label="$t('enterCarRegNum.registrationNumber')" 
          required
        ></LabelTextField>
        <v-btn
          class="submit-btn"
          type="submit"
          height="45px"
          color="#033e8c"
          depressed
          block
          dark
          >
          {{ title }}
        </v-btn>
      </form>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"
import LabelTextField from "@/components/common/LabelTextField.vue"

export default {
  name: "EnterCarRegNumPage",
  props: {},
  components: {
    AppBar,
    LabelTextField
  },
  data() {
    return {
      title: '',
      valid: false,
    }
  },
  methods: {
    submit() {
      const variables = {
        "variables": {
          "license_plate_number": {
            "value": this.$refs.licensePlateNumber.textValue
          }
        }
      }

      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    },
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName
    const pid = this.$store.getters.getCurrentPID
    this.$store.dispatch('retrieveProcessVariables', pid)
    .then(response => {
      try {
        this.$refs.licensePlateNumber.textValue = response.data.data.license_plate_number.value
      } catch (error) {
        console.log("Failed retrieving variables from API.", error)
      }
    })
    .catch(error => {
      console.log("Failed retrieving variables from API", error)
    })
  }
}
</script>

<style scoped>
</style>